import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import React, { useState } from "react";
import { CardGrid, Image } from "../../../../Styles/style";
import SectionsHeading from "../../../MainComponent/SectionsHeading";
import Paragraph from "../../../MainComponent/Paragraph";
import image from "../../../../../assets/Images/largeshia.png";
import CustomButton from "../../../MainComponent/CustomBtn";

const GridWrapper = styled(Grid)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: auto;
  column-gap: 20px;
  row-gap: 20px;
`;

const RowDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
`;
const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0 10px;
  column-gap: 5px;
`;
const InputDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background-color: #333333;
  border-radius: 10px;
  padding: 5px 10px;
`;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background-color: #0d0d0d;
  border-radius: 10px;
  padding: 10px;
`;
const Input = styled.input`
  background-color: transparent;
  color: #fff;
  font-family: PoppinsR;
  font-size: 16px;
  width: 100%;
  padding: 0 10px;
  box-shadow: none;
  border: none;
  :focus {
    outline: none;
  }
`;
const CoulmnDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const AmountSelectPage = () => {
  const [inputValue, setInputValue] = useState(0);
  const [innerSecState, setInnerSecState] = useState(0);

  const handleChange = (value) => {
    setInputValue(value);
  };

  return (
    <GridWrapper container>
      <CardGrid itemxs={12} sm={5.7}>
        <SectionsHeading
          fm="PoppinsSB"
          fs="16px"
          fs599="16px"
          ta="left"
          color="#FC9D00"
        >
          Supply SHIA
        </SectionsHeading>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Your Wallet balance:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            1000
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Your Balance In SHIAVAULT:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            0
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Deposit APY:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            0
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Can be use as collateral:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left" color="#9CFF1A">
            Yes
          </Paragraph>
        </RowDiv>
      </CardGrid>
      {/* ///////////////////////////////////////// */}
      <CardGrid itemxs={12} sm={5.8}>
        <SectionsHeading
          fm="PoppinsSB"
          fs="16px"
          fs599="16px"
          ta="left"
          color="#FC9D00"
        >
          SHIA Reserves Overview
        </SectionsHeading>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Asset Price:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            $0.05
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            SHIA Available Liquidity:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            3000000
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Maximum LTV:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            80%
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Liquidation Threshold:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            85%
          </Paragraph>
        </RowDiv>
        <RowDiv>
          <Paragraph p="0" fs="12px" ta="left" fm="PoppinsB" color="#707070">
            Liquidation Penalty:
          </Paragraph>
          <Paragraph p="0" fs="12px" ta="left">
            5%
          </Paragraph>
        </RowDiv>
      </CardGrid>
      {/* ///////////////////////////////////////// */}
      <CardGrid p="30px 10px" ai="center" jc="center" container item xs={12}>
        <Grid
          item
          xs={12}
          sm={5}
          sx={{
            display: "flex",
            rowGap: "10px",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {innerSecState === 0 ? (
            <>
              <SectionsHeading
                fm="PoppinsSB"
                fs="16px"
                fs599="16px"
                ta="center"
                color="#FC9D00"
              >
                How Much Would You Like To Deposit?
              </SectionsHeading>
              <Paragraph p="0" fs="12px" ta="center">
                Please enter an amount you would like to deposit. The maximum
                amount you can deposit is shown below.
              </Paragraph>
              <RowDiv>
                <Paragraph
                  p="0"
                  fs="12px"
                  ta="center"
                  fm="PoppinsB"
                  color="#707070"
                >
                  Available To Deposit:
                </Paragraph>
                <Paragraph p="0" fs="12px" ta="center" color="#707070">
                  1000 SHIA
                </Paragraph>
              </RowDiv>
              <InputDiv>
                <FlexDiv>
                  <Image src={image} />
                  <Input
                    value={inputValue}
                    onChange={(event) => {
                      handleChange(event.target.value);
                    }}
                  />
                </FlexDiv>
                <CustomButton
                  w="30px"
                  bgc="transparent"
                  c="#FE9C02"
                  hbgc="transparent"
                  hc="#FE9C02"
                >
                  MAX
                </CustomButton>
              </InputDiv>
            </>
          ) : innerSecState === 1 ? (
            <>
              <SectionsHeading
                fm="PoppinsSB"
                fs="16px"
                fs599="16px"
                ta="center"
                color="#FC9D00"
              >
                Deposit Overview
              </SectionsHeading>
              <Paragraph p="0" fs="12px" ta="center">
                These are your transaction details. Make sure to check if this
                is correct before submitting.
              </Paragraph>
              <Div>
                <RowDiv>
                  <Paragraph
                    fs="12px"
                    ta="center"
                    fm="PoppinsB"
                    color="#707070"
                  >
                    Available To Deposit:
                  </Paragraph>
                  <FlexDiv>
                    <Image mw="20px" src={image} />
                    <Paragraph fs="14px" ta="center">
                      {inputValue}
                    </Paragraph>
                  </FlexDiv>
                </RowDiv>
                <RowDiv>
                  <Paragraph
                    fs="12px"
                    ta="center"
                    fm="PoppinsB"
                    color="#707070"
                  >
                    Can be use as collateral:
                  </Paragraph>
                  <FlexDiv>
                    <Paragraph fs="12px" ta="center" color="#9CFF1A">
                      Yes
                    </Paragraph>
                  </FlexDiv>
                </RowDiv>
              </Div>
            </>
          ) : innerSecState === 2 ? (
            <>
              <SectionsHeading
                fm="PoppinsSB"
                fs="16px"
                fs599="16px"
                ta="center"
                color="#FC9D00"
              >
                Deposit Overview
              </SectionsHeading>
              <Paragraph p="0" fs="12px" ta="center">
                These are your transaction details. Make sure to check if this
                is correct before submitting.
              </Paragraph>
              <Div>
                <RowDiv>
                  <Paragraph
                    fs="12px"
                    ta="center"
                    fm="PoppinsB"
                    color="#707070"
                  >
                    Available To Deposit:
                  </Paragraph>
                  <FlexDiv>
                    <Image mw="20px" src={image} />
                    <Paragraph fs="14px" ta="center">
                      {inputValue}
                    </Paragraph>
                  </FlexDiv>
                </RowDiv>
                <RowDiv>
                  <Paragraph
                    fs="12px"
                    ta="center"
                    fm="PoppinsB"
                    color="#707070"
                  >
                    Can be use as collateral:
                  </Paragraph>
                  <FlexDiv>
                    <Paragraph fs="12px" ta="center" color="#9CFF1A">
                      Yes
                    </Paragraph>
                  </FlexDiv>
                </RowDiv>
              </Div>
            </>
          ) : (
            <>
              <SectionsHeading
                fm="PoppinsSB"
                fs="16px"
                fs599="16px"
                ta="center"
                color="#FC9D00"
              >
                Deposit Overview
              </SectionsHeading>
              <Paragraph p="0" fs="12px" ta="center">
                Your action has been successfully executed
              </Paragraph>
              <Div>
                <CoulmnDiv>
                  <Image mw="60px" src={image} />
                  <Paragraph
                    fs="12px"
                    fm="PoppinsB"
                    ta="center"
                    color="#9CFF1A"
                  >
                    1000 SHIA Token Successfully Deposited
                  </Paragraph>
                </CoulmnDiv>
              </Div>
            </>
          )}

          <RowDiv>
            <CustomButton
              m="0"
              onClick={() => {
                setInnerSecState(innerSecState + 1);
              }}
              bgc="#FE9C02"
              c="#000"
              hbgc="#000"
              hc="#FE9C02"
            >
              {innerSecState === 0
                ? "Continue"
                : innerSecState === 1
                ? "Approve"
                : innerSecState === 2
                ? "Deposit"
                : "Dashboard"}
            </CustomButton>
            <Paragraph
              p="0"
              fs="12px"
              ta="center"
              fm="PoppinsB"
              color="#707070"
            >
              {innerSecState === 0
                ? "0/3"
                : innerSecState === 1
                ? "1/3"
                : innerSecState === 2
                ? "2/3"
                : "3/3"}
            </Paragraph>
          </RowDiv>
        </Grid>
      </CardGrid>
      {/* ///////////////////////////////////////// */}
    </GridWrapper>
  );
};

export default AmountSelectPage;
